import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Filter from '../../../../Filters/Filter';
import TwSlider from '../../../../TwSlider';
import useTourFilter from '../../../../../hooks/useTourFilter';

const dayStart = 0;
const dayEnd = 24 * 60;
const step = 30;

const toMinutes = (time) => {
  if (!time) {
    return null;
  }
  const [hours, minutes] = time.split(':');
  return Number.parseInt(hours, 10) * 60 + Number.parseInt(minutes, 10);
};

const toTime = (minutes) =>
  `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;

const TourTimeWindowFilter = ({ tripId, variant, filterSpacingClass }) => {
  const { searchObj, applyFilter } = useTourFilter(tripId);
  const [sliderValue, setSliderValue] = useState([dayStart, dayEnd]);

  useEffect(() => {
    setSliderValue([
      toMinutes(searchObj.earliestStartTime) ?? dayStart,
      toMinutes(searchObj.finishesBy) ?? dayEnd,
    ]);
  }, [searchObj.earliestStartTime, searchObj.finishesBy]);

  const isEmpty = !searchObj.earliestStartTime && !searchObj.finishesBy;

  const handleCommit = (event, value) => {
    applyFilter({
      earliestStartTime: value[0] > dayStart ? toTime(value[0]) : undefined,
      finishesBy: value[1] < dayEnd ? toTime(value[1]) : undefined,
    });
  };

  return (
    <Filter
      label="Time window"
      menuWidthClass="w-max"
      isFilterEmpty={isEmpty}
      variant={variant}
      filterMaxWidthClass="max-w-full"
      handleClear={() => applyFilter({ earliestStartTime: undefined, finishesBy: undefined })}
      filterSpacingClass={filterSpacingClass}
    >
      <div className="px-5 pt-4 w-64">
        <div className="grid grid-cols-3 mb-1">
          <div className="text-sm text-gray-700 whitespace-no-wrap">Tour fits between:</div>
          <div className="col-span-2 text-right text-xs text-gray-700">
            {toTime(sliderValue[0])} -{' '}
            {sliderValue[1] === dayEnd ? '24:00' : toTime(sliderValue[1])}
          </div>
        </div>
        <TwSlider
          value={sliderValue}
          onChange={(event, value) => setSliderValue(value)}
          onChangeCommitted={handleCommit}
          min={dayStart}
          max={dayEnd}
          step={step}
        />
      </div>
    </Filter>
  );
};

TourTimeWindowFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};

TourTimeWindowFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};

export default TourTimeWindowFilter;
